import React, { Component } from 'react'
import { connect } from 'react-redux'

import App from './App'
import {toggleDrawer, setVAS} from './app-reducer'
import {logout, getSession, getSessionFromVAS} from '../login/auth-reducer'
import { fetchProducts } from '../products/products-reducer'
import { fetchLocations } from '../locations/locations-reducer'
import { fetchDrivers } from '../app/users-reducer'
import { fetchJobs } from '../jobs/jobs-reducer'

class AppContainer extends Component {
  componentDidMount () {
    const {
      getSessionFromVAS,
      getSession,
      fetchProducts,
      fetchLocations,
      fetchDrivers,
      fetchJobs,
      authentication,
      setVAS
    } = this.props

    if (authentication) {
      setVAS(true)
      getSessionFromVAS(authentication.getSession)
    } else {
      getSession()
    }

    fetchProducts()
    fetchLocations()
    fetchDrivers()
    fetchJobs()
  }

  render () {
    const {
      logout,
      isDrawerOpen,
      isVAS,
      toggleDrawer,
      routerParams
    } = this.props

    const handleToggleDrawer = () => toggleDrawer(isDrawerOpen)

    return <App
      logout={logout}
      isDrawerOpen={isDrawerOpen}
      isVAS={isVAS}
      onToggleDrawer={handleToggleDrawer}
      routerParams={routerParams}
    />
  }
}

const mapStateToProps = ({app}) => ({...app})
const mapDispatchToProps = {
  logout,
  getSession,
  getSessionFromVAS,
  toggleDrawer,
  setVAS,
  fetchProducts,
  fetchLocations,
  fetchDrivers,
  fetchJobs
}

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer)



// WEBPACK FOOTER //
// ./src/app/AppContainer.js